import { render, staticRenderFns } from "./EstoqueAtual.vue?vue&type=template&id=ac379456&scoped=true"
import script from "./EstoqueAtual.vue?vue&type=script&lang=js"
export * from "./EstoqueAtual.vue?vue&type=script&lang=js"
import style0 from "./EstoqueAtual.vue?vue&type=style&index=0&id=ac379456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac379456",
  null
  
)

export default component.exports